<template>
    <v-snackbar
            v-model="notification"
            :color="notification_type"
            :timeout="3000"
    >
        {{ notification_message }}
        <v-btn

                text
                @click="notification = false"
        >
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        name: 'notification-item',
        components: {},
        props: {
            notification: Boolean,
            notification_message:String,
            notification_type:String,
        },
        data() {
            return {

            }
        }
    }
</script>
